import React from 'react';
import Select from 'react-select';

import './SubQueryOption.css';

const SubSelect = (props) => {
  let key;
  // if (!props.mainQuery){
  // }
  // else {
  //   key = `${props.mainQuery}`
  // }
  if(!props.mainQuery) {
    key = `select-all`
  }
  else {
    key = `${props.mainQuery}`
  }
  return props.edit ?
  (
    <Select key={key} placeholder="서브 검색어 찾기" isClearable={true} isSearchable={true}
      defaultValue={props.defaultValue}
      options={props.multiQuerySelectOption}
      isMulti
      styles={{
        container: base => ({
          ...base,
          width: "250px"
        }),
        option: base => ({
          ...base,
          textAlign: "left"
        })
      }}
      onChange={(e)=>{
        props.selectSubQuery(e);
      }}
    />
  )
  :  (
    <Select key={key} placeholder="서브 검색어 찾기" isClearable={true} isSearchable={true}
      value={props.subQueryOptionList}
      options={props.multiQuerySelectOption}
      isMulti
      styles={{
        container: base => ({
          ...base,
          width: "250px"
        }),
        option: base => ({
          ...base,
          textAlign: "left"
        })
      }}
      onChange={(e)=>{
        props.selectSubQuery(e);
      }}
    />
  )
}

const SubQueryOption = (props) => {
//props.subQueryType = "compare" "cross"
  const activeStyle = {
    background: '#6E37FA',
    border:'1px solid #6E37FA',
    color: '#ffffff'
  }
  
  return (
    <div className="option_subQuery">
      <div className="optionSetting1">
        <div className="optionSettingTit">
          Sub Keyword
        </div>
        <div className="optionSettingBtn2">
          {props.subQueryType =="compare" ?
            <>
              <a className="button smallOpt" style={activeStyle} name="compare" onClick={(e)=>props.handleSubQueryType(e)}>비교</a>&nbsp;
              <a className="button smallOpt" name="cross" onClick={(e)=>props.handleSubQueryType(e)}>교차</a>
            </>
          :
            <>
              <a className="button smallOpt" name="compare" onClick={(e)=>props.handleSubQueryType(e)}>비교</a>&nbsp;
              <a className="button smallOpt" style={activeStyle} name="cross" onClick={(e)=>props.handleSubQueryType(e)}>교차</a>
            </>}
        </div>
        <div class="subQueryLine">
          {React.useMemo(()=>{
            return props.edit ? (
              <SubSelect edit={true} defaultValue={props.defaultQuery.subQuery} mainQuery={props.mainQuery} multiQuerySelectOption={props.multiQuerySelectOption} selectSubQuery={props.selectSubQuery} />
            )
            :(
              <SubSelect subQueryOptionList={props.subQueryOptionList} mainQuery={props.mainQuery} multiQuerySelectOption={props.multiQuerySelectOption} selectSubQuery={props.selectSubQuery} />
            )
          }, [props.multiQuerySelectOption])}
        </div>
      </div>
    </div>
  )
}

export default SubQueryOption;